import {asGatsbyImageDataAccess, getFirstSrcFromSources} from './gatsbyImageDataAccess';
import type {BrandLogoResource} from '../types/imageResources';
import type {IGatsbyImageData} from 'gatsby-plugin-image';

export type BrandLogoQueryResult = {
  readonly file: {
    readonly childImageSharp: {
      readonly gatsbyImageData: IGatsbyImageData;
    } | null;
  } | null;
};

export const resolveBrandLogoResource = (data: BrandLogoQueryResult): BrandLogoResource => {
  const gatsbyImageData = data.file?.childImageSharp?.gatsbyImageData;

  if (!gatsbyImageData) {
    throw new Error(`Brand logo image data is missing. Ensure logo-square.png is available to Gatsby.`);
  }

  const parsedImageData = asGatsbyImageDataAccess(gatsbyImageData);
  const fallbackSrc = parsedImageData.images.fallback?.src ?? getFirstSrcFromSources(parsedImageData.images.sources) ?? null;

  if (!fallbackSrc) {
    throw new Error(`Unable to derive fallback src for the brand logo image.`);
  }

  return {
    gatsbyImageData,
    src: fallbackSrc,
    placeholderSrc: parsedImageData.placeholder?.fallback ?? null,
  };
};
